import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import SrModalV2, { MODAL_THEME_STACK } from 'client/components/SrModalV2/SrModalV2';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_BLUE,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';

const getFormFields = ({ formValues }) => {
  const formFields = [
    {
      id: 'hasSsn',
      type: 'simple_checkbox',
      properties: {
        children: (
          <SrText weight="800" color={formValues.hasSsn ? 'green' : 'blueGreycliff'}>
            I do not have an SSN or ITIN
          </SrText>
        ),
        className: 'adobeCheckboxSquare',
      },
      validations: ['requiredCheck::Press “I do not have an SSN or ITIN” to continue'],
    },
  ];
  return formFields;
};

const initialValues = {
  hasSsn: false,
};

const SrModalConfirmNoSsn = ({ onContinue, onClose }) => {
  return (
    <Formik
      initialValues={createInitialValues({
        formFields: getFormFields({ formValues: initialValues }),
        defaultValues: initialValues,
      })}
      enableReinitialize
      validate={(formValues) => {
        const formFields = getFormFields({ formValues });
        return createFormValidationFn(formFields)(formValues);
      }}
      onSubmit={onContinue}
    >
      {(formikBag) => {
        const { values } = formikBag;
        const formFields = getFormFields({
          formValues: values,
        });

        return (
          <SrModalV2
            showCloseButton={false}
            contentMaxWidth="343px"
            padding="0"
            margin="1vh auto 0 auto"
            contentPadding="30px 34px"
            contentOverflow="unset"
            theme={MODAL_THEME_STACK}
          >
            <SrBox>
              <SrBox
                margin="0 auto"
                backgroundSize="contain"
                backgroundRepeat="no-repeat"
                backgroundPosition="center"
                backgroundImage="url(/images/warning-triangle-orange-large.svg)"
                width="100px"
                height="94px"
              />
              <SrFlex align="center" marginTop="16px">
                <SrText font="greycliff" weight="800" fontSize="26px" align="center">
                  Apply Without SSN/ITIN?
                </SrText>
              </SrFlex>
              <SrBox marginTop="24px">
                <SrText font="greycliff" fontSize="14px">
                  If you have an SSN or ITIN, you are required to provide it. If you have one, press
                  Close and enter it.
                </SrText>
              </SrBox>
              <SrBox marginTop="5px">
                <SrText font="greycliff" fontSize="14px">
                  If you do not have an SSN or ITIN, press the checkbox below and press Continue.
                </SrText>
              </SrBox>
              <SrBox marginTop="-8px">
                <Form>
                  {formFields.map((formField) => (
                    <SrFormikField
                      key={formField.id}
                      formField={formField}
                      formikBag={formikBag}
                      theme={SR_FIELD_THEME_ADOBE}
                      margin={formField.margin}
                    />
                  ))}
                  <SrBox marginTop="16px">
                    <SrButton theme={SR_BUTTON_THEME_ADOBE_BLUE} type="submit">
                      Continue
                    </SrButton>
                    <SrBox marginTop="16px">
                      <SrButton theme={SR_BUTTON_THEME_ADOBE_GREY} onClick={onClose}>
                        Close
                      </SrButton>
                    </SrBox>
                  </SrBox>
                </Form>
              </SrBox>
            </SrBox>
          </SrModalV2>
        );
      }}
    </Formik>
  );
};

SrModalConfirmNoSsn.displayName = 'SrModalConfirmNoSsn';

SrModalConfirmNoSsn.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SrModalConfirmNoSsn;
